import 'directive/xmllint';
import 'factory/consts';
import 'factory/countries';
import 'factory/showXML';
import 'factory/REST';
import 'factory/alert';
import xmllint from 'xmllint-extra';
import xsdSig from '../../schema/xmldsig-core-schema.xsd';
import xsdFattura from '../../schema/fattura.xsd';

angular.module('TInv.ctrl.Form', [
    'ui.bootstrap',
    'TInv.dir.xmllint',
    'TInv.consts',
    'TInv.countries',
    'TInv.showXML',
    'TInv.REST',
    'TInv.util',
]).controller('FormCtrl', function ($log, $scope, $window, x2js, Consts, countries, showXML, REST, alert, delayed, checkPartitaIVA) {
    function objectEmpty(o) {
        return (Object.keys(o).length === 0);
    }
    const
        reFixed8 = /^(PrezzoUnitario|PrezzoTotale|Quantita|CapitaleSociale)$/,
        reFixed2 = /Importo|Prezzo|Imposta|Quantita|Aliquota|AlCassa|Arrotondamento|ImportoBollo/,
        trailingZeros = /([.][0-9]{2}([0-9]*[1-9])?)0+$/;
    function preprocessXML(obj) {
        for (var k in obj) {
            if (k.charAt(0) == '$' || obj[k] === null || obj[k] === '' || obj[k] === false || typeof obj[k] === 'undefined')
                delete obj[k];
            else if (typeof obj[k] == 'object') {
                preprocessXML(obj[k]);
                if (objectEmpty(obj[k]))
                    delete obj[k];
            } else if (obj[k] === true)
                obj[k] = 'SI';
            else if (reFixed8.test(k))
                obj[k] = Number(obj[k]).toFixed(8).replace(trailingZeros, '$1');
            else if (reFixed2.test(k))
                obj[k] = Number(obj[k]).toFixed(2);
        }
    }

    const validate = delayed(500, function () {
        const t0 = Date.now();
        try {
            const
                tree = $scope.getJSON(),
                head = tree.FatturaElettronica.FatturaElettronicaHeader,
                fakeIdF = {
                    IdPaese: 'IT',
                    IdCodice: '0'
                },
                fakeCP = {
                    DatiAnagrafici: {
                        IdFiscaleIVA: fakeIdF,
                        Anagrafica: {
                            Denominazione: 'A'
                        },
                        RegimeFiscale: 'RF01'
                    },
                    Sede: {
                        Indirizzo: 'a',
                        CAP: '20100',
                        Comune: 'MI',
                        Nazione: 'IT'
                    }
                };
            // add fake values necessary to complete validation
            head.DatiTrasmissione.IdTrasmittente = fakeIdF;
            head.DatiTrasmissione.ProgressivoInvio = '00000';
            head.DatiTrasmissione.CodiceDestinatario = head.DatiTrasmissione.CodiceDestinatario || '1234567';
            head.CedentePrestatore = fakeCP;
            preprocessXML(tree);
            const
                offsets = {},
                xml = x2js.json2xml_str(tree, offsets);
            $scope.lint = xmllint.validateXML({
                xml: xml,
                schema: [ xsdSig, xsdFattura ]
            });
            if (!$scope.lint.errors) return;
            $scope.lint.errors.forEach(e => {
                e.message = e.message.replace(/^Element '[^']+': /, '');
                if (e.offset && offsets[e.offset])
                    e.path = offsets[e.offset].path;
            });
        } catch (e) {
            $log.error('XMLLint exception:', e);
            $scope.lint = [ { message: 'Parsing error.' } ];
        } finally {
            $log.debug('XMLLint time: ' + (Date.now() - t0) + 'ms');
            $scope.$broadcast('xmlLint', $scope.lint);
        }
    });

    $scope.validPartitaIVA = false;

    $scope.$watch('[fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese,fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice]', function () {
        const iva = $scope.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA;
        $scope.validPartitaIVA = (iva == null || iva.IdPaese != 'IT') ? null : checkPartitaIVA(iva.IdCodice);
    });

    $scope.allowB2B = true;
    $scope.getJSON = function () {
        completaFattura();
        var data = angular.copy($scope.fattura);
        if (data.FatturaElettronicaBody.Allegati && !data.FatturaElettronicaBody.Allegati.Attachment)
            delete data.FatturaElettronicaBody.Allegati;
        if (data.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA && !data.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice)
            delete data.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA;
        data['__prefix'] = 'f';
        data['_xmlns:f'] = 'http://ivaservizi.agenziaentrate.gov.it/docs/xsd/fatture/v1.2';
        data['_versione'] = 'FPA12';
        try {
            if (data.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario.length == 7)
                data['_versione'] = 'FPR12';
        } catch (e) {
            // ignore (probably missing CodiceDestinatario)
        }
        data.FatturaElettronicaHeader.DatiTrasmissione.FormatoTrasmissione = data['_versione'];
        data = { 'FatturaElettronica': data }; // root
        return data;
    };
    $scope.preview = function () {
        var data = $scope.getJSON();
        preprocessXML(data);
        var xml = x2js.json2xml_str(data);
        //$log.info('About to show XML:', xml);
        showXML(1, xml);
    };
    $scope.compileIPA = function (ipa) {
        var h = $scope.fattura.FatturaElettronicaHeader,
            cc = h.CessionarioCommittente;
        h.DatiTrasmissione.CodiceDestinatario = ipa.cod;
        cc.DatiAnagrafici.CodiceFiscale = ipa.cf;
        cc.DatiAnagrafici.Anagrafica.Denominazione = ipa.nome;
        cc.Sede.Indirizzo = ipa.indirizzo;
        cc.Sede.CAP = ipa.cap;
        cc.Sede.Comune = ipa.comune;
        cc.Sede.Provincia = ipa.provincia;
        cc.Sede.Nazione = 'IT';
    };
    $scope.$watch('fattura',
        delayed(100,
            function () {
                $log.debug('Invoice changed.');
                $scope.$broadcast('invoiceChanged');
                validate();
            },
            true /* skip apply, we don't change the model */),
        true /*deep equal*/);
    $scope.$watch('fattura.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario', function () {
        //var dest = $scope.fattura.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario || '';
        //$log.debug('Search COD:', dest);
        //if (dest !== '0000000')
        //    $scope.fattura.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = '';
        //IndicePA.byCOD(dest).then(function (ipa) {
        //    $log.debug('Found COD:', ipa);
        //    $scope.foundCOD = ipa;
        //});
    });
    $scope.$watch('fattura.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario', function () {
        var dest = $scope.fattura.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario || '';
        if (dest.length > 1)
            $scope.fattura.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '0000000';
    });
    $scope.$watch('fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale', function () {
        //var cf = $scope.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale;
        //IndicePA.byCF(cf).then(function (ipa) {
        //    $log.debug('Found CF:', ipa);
        //    $scope.foundCF = ipa;
        //});
    });
    $scope.edit = { row: null };
    function updateRowTotal() {
        if (!$scope.edit.row) return;
        var q = $scope.edit.row.Quantita || 1; // missing quantità is an implicit 1
        $scope.edit.row.PrezzoTotale = q * $scope.edit.row.PrezzoUnitario;
    }
    $scope.$watch('edit.row.Quantita', updateRowTotal);
    $scope.$watch('edit.row.PrezzoUnitario', updateRowTotal);
    function completaFattura() {
        function getRiepilogo(linea) {
            var r;
            for (var i = 0; i < riepilogo.length; ++i) {
                r = riepilogo[i];
                if (r.AliquotaIVA == linea.AliquotaIVA && (r.AliquotaIVA > 0 || r.Natura == linea.Natura))
                    return r;
            }
            // not found, create a new one
            r = angular.copy(Consts.baseRiepilogo);
            r.AliquotaIVA = linea.AliquotaIVA;
            if (linea.AliquotaIVA === 0) {
                r.Natura = linea.Natura;
                r.RiferimentoNormativo = $scope.fattura.$RiferimentoNormativo[r.Natura];
            } else {
                r.Natura = null;
                r.RiferimentoNormativo = null;
            }
            r.EsigibilitaIVA = $scope.fattura.$EsigibilitaIVA;
            riepilogo.push(r);
            return r;
        }
        var body = $scope.fattura.FatturaElettronicaBody,
            //totale = 0,
            //pagamento = 0,
            linee = body.DatiBeniServizi.DettaglioLinee,
            riepilogo = body.DatiBeniServizi.DatiRiepilogo = [],
            datiPagamento = body.DatiPagamento;
        linee.forEach(function (linea, idx) {
            linea.NumeroLinea = (idx + 1);
            if (linea.AliquotaIVA !== 0)
                linea.Natura = '';
            var r = getRiepilogo(linea);
            r.ImponibileImporto += linea.PrezzoTotale;
        });
        riepilogo.forEach(function (r) {
            r.Imposta = r.ImponibileImporto * r.AliquotaIVA * 1e-2;
            //totale += r.ImponibileImporto + r.Imposta;
            //pagamento += r.ImponibileImporto;
            if (r.EsigibilitaIVA != 'S'){
                //pagamento += r.Imposta;
            }
        });
        if(datiPagamento == null || datiPagamento.length<1){
            $log.info('Non aggiungo i campi necessari al pagamento');
            $scope.fattura.FatturaElettronicaBody.DatiPagamento = [];
        }else{
            $log.info('Dati pagamento presenti');
        }
    }
    $scope.addRow = function () {
        var linea = angular.copy(Consts.baseLinea);
        $scope.edit.row = linea;
        $scope.fattura.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.push(linea);
    };
    $scope.deleteRow = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.splice(idx, 1);
    };
    $scope.editRow = function (row) {
        $scope.edit.row = row;
    };

    $scope.editDDT = { rowDDT: null };
    $scope.addRowDDT = function () {
        var linea = angular.copy(Consts.baseDDT);
        $scope.editDDT.rowDDT = linea;
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiDDT.push(linea);
    };
    $scope.deleteRowDDT = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiDDT.splice(idx, 1);
    };
    $scope.editRowDDT = function (row) {
        $scope.editDDT.rowDDT = row;
    };

    $scope.editCassa = { rowCassa: null };
    $scope.addRowCassa = function () {
        var linea = angular.copy(Consts.baseCassa);
        //$log.debug('Linea originale:',linea);
        $scope.editCassa.rowCassa = linea;
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.push(linea);
        //$log.debug('Linea in fattura body:',$scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale);
    };
    $scope.deleteRowCassa = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.splice(idx, 1);
    };
    $scope.editRowCassa = function (row) {
        $scope.editCassa.rowCassa = row;
    };

    $scope.editPagamento = { rowPagamento: null };
    $scope.addRowPagamento = function () {
        var linea = angular.copy(Consts.basePagamento);
        var lineaDettaglioPagamento = angular.copy(Consts.baseDettaglioPagamento);
        //$log.debug('Linea originale:',linea);
        //$log.debug('Linea originale dettaglio:',lineaDettaglioPagamento);
        $scope.editPagamento.rowPagamento = linea;
        $scope.editPagamento.rowPagamento.DettaglioPagamento.push(lineaDettaglioPagamento);
        //$log.debug('Linea aggiunta a editPagamento:',$scope.editPagamento.rowPagamento);
        //log.debug('Attuale datiPagamento:',$scope.fattura.FatturaElettronicaBody.DatiPagamento);
        $scope.fattura.FatturaElettronicaBody.DatiPagamento.push(linea);
    };
    $scope.deleteRowPagamento = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiPagamento.splice(idx, 1);
    };
    $scope.editRowPagamento = function (row) {
        $scope.editPagamento.rowPagamento = row;
    };

    $scope.editDOA = { rowDOA: null };
    $scope.addRowDOA = function () {
        var linea = angular.copy(Consts.baseDatiOrdineAcquisto);
        $scope.editDOA.rowDOA = linea;
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto.push(linea);
    };
    $scope.deleteRowDOA = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto.splice(idx, 1);
    };
    $scope.editRowDOA = function (row) {
        $scope.editDOA.rowDOA = row;
    };

    $scope.editDatiRicezione = { rowDatiRicezione: null };
    $scope.addRowDatiRicezione = function () {
        //Same base line as DatiOrdineAcquisto
        var linea = angular.copy(Consts.baseDatiOrdineAcquisto);
        $scope.editDatiRicezione.rowDatiRicezione = linea;
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiRicezione.push(linea);
    };
    $scope.deleteRowDatiRicezione = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiRicezione.splice(idx, 1);
    };
    $scope.editRowDatiRicezione = function (row) {
        $scope.editDatiRicezione.rowDatiRicezione = row;
    };

    $scope.editDatiContratto = { rowDatiContratto: null };
    $scope.addRowDatiContratto = function () {
        //Same base line as DatiOrdineAcquisto
        var linea = angular.copy(Consts.baseDatiOrdineAcquisto);
        $scope.editDatiContratto.rowDatiContratto = linea;
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiContratto.push(linea);
    };
    $scope.deleteRowDatiContratto = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiContratto.splice(idx, 1);
    };
    $scope.editRowDatiContratto = function (row) {
        $scope.editDatiContratto.rowDatiContratto = row;
    };

    $scope.editDatiConvenzione = { rowDatiConvenzione: null };
    $scope.addRowDatiConvenzione = function () {
        //Same base line as DatiOrdineAcquisto
        var linea = angular.copy(Consts.baseDatiOrdineAcquisto);
        $scope.editDatiConvenzione.rowDatiConvenzione = linea;
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiConvenzione.push(linea);
    };
    $scope.deleteRowDatiConvenzione = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiConvenzione.splice(idx, 1);
    };
    $scope.editRowDatiConvenzione = function (row) {
        $scope.editDatiContratto.rowDatiConvenzione = row;
    };

    $scope.editDFC = { rowDFC: null };
    $scope.addRowDFC = function () {
        //Same base line as DatiOrdineAcquisto
        var linea = angular.copy(Consts.baseDatiOrdineAcquisto);
        $scope.editDFC.rowDFC = linea;
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate.push(linea);
    };
    $scope.deleteRowDFC = function (idx) {
        $scope.fattura.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate.splice(idx, 1);
    };
    $scope.editRowDFC = function (row) {
        $scope.editDFC.rowDFC = row;
    };

    $scope.tipiDocumento = Consts.tipiDocumento;
    $scope.tipiRitenuta = Consts.tipiRitenuta;
    $scope.tipiEsigibilitaIVA = Consts.tipiEsigibilitaIVA;
    $scope.tipiPagamento = Consts.tipiPagamento;
    $scope.modalitaPagamento = Consts.modalitaPagamento;
    $scope.tipiCassa = Consts.tipiCassa;
    $scope.nature = Consts.nature;
    $scope.causaliRitenuta = Consts.causaliRitenuta;
    $scope.regimi = Consts.regimi;
    $scope.paesi = countries;
    $scope.attach = {};
    $scope.clearAttach = function () {
        $scope.attach = {};
        $scope.fattura.FatturaElettronicaBody.Allegati.Attachment = null;
        $scope.fattura.FatturaElettronicaBody.Allegati.NomeAttachment = '';
    };

    $scope.fattura = angular.copy(Consts.baseFattura);

    function forzaTipi(o) {
        for (var k in o) {
            if (typeof o[k] == 'function')
                continue;
            var t = Consts.tipiXML[k];
            if (t && o[k] !== undefined && o[k] !== null && !(o[k] instanceof t))
                o[k] = t(o[k]);
            if (typeof o[k] == 'object')
                forzaTipi(o[k]);
        }
    }

    //AXO EDIT
    $scope.sendXMLform = function () {
        var data = $scope.getJSON();
        preprocessXML(data);
        return $scope.sendXML(
            $scope.fatturaForm.name,
            data.FatturaElettronica.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario || data.FatturaElettronica.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario,
            data.FatturaElettronica.FatturaElettronicaHeader.CessionarioCommittente,
            data.FatturaElettronica.FatturaElettronicaBody);
    };

    $scope.refuseForm = function () {
        return $scope.refuseMessage($scope.fatturaForm.name);
    };

    $scope.filePreLoad = function (xml) { 
        var data = x2js.xml_str2json(xml);
        forzaTipi(data);
        $scope.fattura = data.FatturaElettronica;
        try {
            $scope.fattura.$tipo = $scope.fattura.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario.length < 7 ? 'FPA' : 'B2B';
        } catch (e) {
            $scope.fattura.$tipo = 'B2B';
        }
        try{
            if($scope.fattura.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario === '1234567')
                $scope.fattura.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '0000000';
        }catch(e){/*ignore*/}
        try{
            if($scope.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale.startsWith('XXXXXX'))
                $scope.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = '';
        }catch(e){/*ignore*/}
        // TODO? $scope.fattura.$EsigibilitaIVA = $scope.fattura.…
        $scope.fattura.$RiferimentoNormativo = {};
        if ($scope.fattura.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo)
            $scope.fattura.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.forEach(function (r) {
                if (r.Natura)
                    $scope.fattura.$RiferimentoNormativo[r.Natura] = r.RiferimentoNormativo;
            });
        $scope.fattura.FatturaElettronicaHeader.CedentePrestatore = null;
        delete $scope.fattura.Signature;
        $scope.codice = $scope.selected.client.IdCodice;
        $log.info('Fattura:', $scope.fattura);
    };
    //$log.debug('filePreLoad input : ', $scope.fatturaForm.xml);
    $scope.filePreLoad($scope.fatturaForm.xml);
    $scope.backToList = function () {
        //set state back to list
        $scope.fatturaForm.xml = '';
        $scope.setState('list-att');
    };
});
